import {
  AREA,
  LINE_GRAPH,
  LINE_HIGH_CHART,
  LOCATION,
  TEXT,
} from '../../../Constants/WidgetTypes';
const TIMESERIES_TYPES = new Set([LINE_HIGH_CHART, LINE_GRAPH, LOCATION, AREA]);

export function isTimeFilterVisible(type, displayTextAsGrid) {
  return TIMESERIES_TYPES.has(type) || (type === TEXT && !displayTextAsGrid);
}
